import {LOAD_DATA, SUCCESS, ITEM} from "../../../constants";

/**
 * Constants
 * */
export const moduleName = 'licenseeStore'

/**
 * Reducer
 * */

export default function reducer(state = null, action) {
    const {type, response} = action

    switch (type) {
        case ITEM + LOAD_DATA + SUCCESS:
            return response.licenseeStore
        default:
            return state
    }
}

/**
 * Selectors
 * */

export const licenseeStoreSelector = (state) => state[moduleName]

/**
 * Action Creators
 * */
